import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

import { SetAllMemberCheck } from '../message.event';
import { AppService } from '../../app.service';
@Component({
    selector: 'member-table',
    templateUrl: './member-table.component.html',
    styleUrls: ['./member-table.component.css'],
    exportAs: 'memberTable'
})
export class MemberTableComponent implements OnInit {
    private _router;
    private popUpMessage: string;
    private vendor;
    private hideEdit: boolean;
    private windowHeight = window.innerHeight;
    private topNav = 56;
    private midNav = 45;
    private footer = 35;
    private container = 10;
    private height: any;
    private divHeight = 30;
    private spacingH = 10;
    private disableOnFirstCheck;
    @Input() allInGroup1 = false;
    private memberListForGroup = [];
    @Input() memberList = [];
    @Input() memberPointer = false;
    @Input() noMemberAvailable = true;
    @Input() searchMember = '';
    @Input() createGroupView = true;
    @Input() selectMember = false;
    @Output() disableSelectMember = new EventEmitter<boolean>();
    @Output() CheckedMembers = new EventEmitter<any>();
    @Output() allMembersChecked = new EventEmitter<any>();
    @Output() changePage = new EventEmitter<any>();
    @Input() showDetails = false;
    private allInGroup = false;
    @Input() totalListCount = 0;
    @Input() currentPage = 1;
    private totalPage = 0;
    @Input() perPageItemSize = 0;
    @Input() statusMember = true;
    private rowItemSizes = [10];
    private noOfPageItem = 10;  // It will set by vendor configuration object
    private startNoOfPageItem = 10;  // It will set by vendor configuration object
    @Input() memberTableHeight = 0;
    private numberOfPageSelect = true; // diable selection of number pages
    private currentNoOfMember = 0;

    constructor(private router: Router, private setAllMemberCheck: SetAllMemberCheck, private appService: AppService) {
        this._router = router;
        this.popUpMessage = 'Is Payment Done';
        this.hideEdit = false;
        this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.spacingH)) + 'px';
        this.disableOnFirstCheck = false;
        this.registerTypeBroadcast();
    }

    ngOnInit() {
        if (localStorage.getItem('vendor')) {
            this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
            this.setAllSelected();
        } else {
            this._router.navigate(['/']);
        }
    }

    ngOnChanges() {
        if (this.totalListCount > 0 && this.noOfPageItem > 0) {
            this.setAllSelected();
            this.totalPage = Math.ceil(this.totalListCount / this.noOfPageItem);
            this.numberOfPageSelect = (this.memberList.length < this.startNoOfPageItem);
            this.currentNoOfMember = this.memberList.length;
            if (this.totalListCount > 30) {
                this.rowItemSizes = [10, 20, 30, 50];
            } else if (this.totalListCount > 20) {
                this.rowItemSizes = [10, 20, 30];
            } else if (this.totalListCount > 10) {
                this.rowItemSizes = [10, 20];
            }
        }
        if (this.memberTableHeight > 0) {
            this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.spacingH + this.memberTableHeight)) + 'px';

        } else {
            this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.spacingH)) + 'px';
        }
    }

    /**
     * TO change status of Select member button only on first check
     */

    disableSelectMemberOnCheck(event): void {
        try {
            if (event.target.checked) {
                this.disableSelectMember.emit(true);
            }
        } catch (e) {
            console.log(e);
        }
    }

    addAllmembersInGroup() {
        try {
            // this.allInGroup = !this.allInGroup;
            let emailIdList = [];
            if (this.allInGroup) {
                this.memberListForGroup = this.memberList.filter(function (mem) {
                    mem.isChecked = true;
                    emailIdList.push(mem.userId);
                    return mem;
                });
            } else {
                this.memberList.map(function (mem) {
                    mem.isChecked = false;
                    emailIdList.push(mem.userId);
                    return mem;
                });
                this.memberListForGroup = [];
                //emailIdList = [];
            }
            this.allMembersChecked.emit(emailIdList);
        } catch (e) {
            console.log(e);
        }
    }

    // passing member object to parent class

    insertIngroupList(e, memberObj) {
        try {
            if (e.target.checked) {
                memberObj.isChecked = e.target.checked;
            } else {
                memberObj.isChecked = false;
            }
            this.setAllSelected();
            this.CheckedMembers.emit(memberObj);
        } catch (e) {
            console.log(e);
        }
    }

    showDetail(memberObj) {
        try {
            localStorage.setItem('memberEmailId', btoa(JSON.stringify(memberObj.emailId)));
            // localStorage.setItem('current memberDetail', btoa(JSON.stringify(memberObj)));
            //this.appService.storeMemberDetail(memberObj);
            this._router.navigate(['/memberdetail']);
        } catch (e) {
            console.log(e);
        }
    }

    pageChangeClick(currentPage, noOfPageItem) {
        if ((noOfPageItem + '').indexOf(':') > -1) {
            this.noOfPageItem = noOfPageItem.split(':')[1].trim();
            currentPage = 1;
        } else {
            this.noOfPageItem = noOfPageItem;
        }
        this.currentPage = currentPage;
        let pageOptions = {
            currentPage: this.currentPage,
            noOfPageItem: this.noOfPageItem
        };
        this.changePage.emit(pageOptions);
        this.setAllSelected();
    }

    setAllSelected() {
        let flag = false;
        this.allInGroup = false;
        for (let member of this.memberList) {
            if (!member.isChecked) {
                flag = true;
                break;
            }
        }
        if (flag) {
            this.allInGroup = false;
        } else if (this.memberList.length > 0) {
            this.allInGroup = true;
        }
    }
    registerTypeBroadcast() {
        this.setAllMemberCheck.on()
            .subscribe(flag => {
                if (flag) {
                    this.setAllSelected();
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/member-table/member-table.component.ts